// Valeurs communes à l’éditeur et au formulaire étudiant ; contenu en texte brut.
const DEFAULT_CONFIRMATION = {
  title: 'Before you continue',
  text: 'Do you confirm that you have read the previous messages?\n\nClick OK to continue or Cancel to read them again.',
  confirmLabel: 'OK',
  cancelLabel: 'Cancel',
  backgroundColor: '#ffffff',
  textColor: '#15344a',
  buttonColor: '#0166a1',
  buttonTextColor: '#ffffff'
};
const isColor = value => typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value);
// Palette réservée aux messages ; l'orange est distinct du #ef7d17 de la charte.
const MESSAGE_COLORS = [
  { label: 'Vert', value: '#419d66' },
  { label: 'Orange', value: '#d99000' },
  { label: 'Rouge', value: '#c84b48' }
];
const MESSAGE_TEXT_COLOR = '#15344a';
function messageColor(value) {
  if (!isColor(value)) return MESSAGE_COLORS[1].value;
  const rgb = color => [1, 3, 5].map(index => parseInt(color.slice(index, index + 2), 16));
  const source = rgb(value);
  const distance = color => rgb(color).reduce((sum, channel, index) => sum + (channel - source[index]) ** 2, 0);
  // Compatibilité des messages déjà enregistrés avec une couleur libre.
  return MESSAGE_COLORS.reduce((closest, color) => distance(color.value) < distance(closest.value) ? color : closest).value;
}
function introductionFromMessages(messages = {}) {
  const confirmation = { ...DEFAULT_CONFIRMATION };
  for (const key of Object.keys(confirmation)) {
    const value = messages.introConfirmation?.[key];
    if (key === 'backgroundColor') continue; // Le fond du dialogue reste blanc.
    if (key.endsWith('Color') ? isColor(value) : typeof value === 'string' && value.trim()) confirmation[key] = value;
  }
  return {
    intro: (Array.isArray(messages.intro) ? messages.intro : []).map((item, index) => ({
      id: item.id || `intro_${index + 1}`,
      text: typeof item.text === 'string' ? item.text : '',
      backgroundColor: messageColor(item.backgroundColor),
      textColor: MESSAGE_TEXT_COLOR
    })),
    confirmation
  };
}
module.exports = { DEFAULT_CONFIRMATION, isColor, introductionFromMessages, MESSAGE_COLORS, MESSAGE_TEXT_COLOR, messageColor };
